import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <section className="w-full px-4 md:px-8 pt-8">
        <Breadcrumb items={[{ name: "首页", to: "/" }, { name: "页面未找到" }]} />
      </section>
      <section className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
        <span className="font-heading text-6xl md:text-8xl font-black text-background-300 select-none">
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这份档案没找着
        </h1>
        <p className="mt-3 text-sm text-foreground-600 max-w-md leading-relaxed">
          你要访问的路径是
          <span className="mx-1 px-2 py-0.5 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-xs">
            {location.pathname}
          </span>
          ，它可能已被移动或从未存在。不如回档案总览逛逛？
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/archive"
            className="px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:bg-background-100 transition-colors text-center whitespace-nowrap"
          >
            浏览考古档案
          </Link>
        </div>
      </section>
    </Layout>
  );
}